import {
    CmsPageComponent as SourceCmsPageComponent,
} from 'SourceRoute/CmsPage/CmsPage.component';

import './CmsPage.override.style';
import React from "react";
import Html from '@scandipwa/scandipwa/src/component/Html';
import NoMatch from '@scandipwa/scandipwa/src/route/NoMatch';
import TextPlaceholder from '@scandipwa/scandipwa/src/component/TextPlaceholder';
import Loader from '@scandipwa/scandipwa/src/component/Loader';
import { createPortal } from 'react-dom';
import history from '@scandipwa/scandipwa/src/util/History';

export class CmsPageComponent extends SourceCmsPageComponent {
    static defaultProps = {
        isBreadcrumbsActive: true,
    };

    renderHeading() {
        const { cmsPage: { content_heading }, isLoading } = this.props;

        if (!content_heading || isLoading) {
            return null;
        }

        return (
            <h1 className='CmsPage-HeadingTitle'>
                <TextPlaceholder content={content_heading} />
            </h1>
        );
    }

    renderContent() {
        const {
            isLoading,
            cmsPage: { content },
        } = this.props;

        if (isLoading) {
            return (
                <>
                    <div />
                    <div />
                    <div />
                </>
            );
        }

        if (!content) {
            return null;
        }
        // console.log(content);
        let parser = new DOMParser().parseFromString(content, 'text/html');
        let data = content?.replaceAll('&lt;', '<');
        let data2 = data?.replaceAll('&gt;', '>');

        return <Html content={data2} />;
        // return <div dangerouslySetInnerHTML={{ __html: parser.body.firstChild.textContent }} />;
    }

    renderMeta = () => {
        const {
            cmsPage
        } = this.props;

        const { meta_description, meta_keywords, meta_title, title } = cmsPage;

        window?.dataLayer?.push({
            ecommerce: {
                title: cmsPage?.title,
            },
            pageType: "cms_page",
        });

        return (
            <>
                <title>{meta_title}</title>
                <link rel="canonical" href={`https://www.bluehira.com${history?.location?.pathname ? history?.location?.pathname : ""}`} />
                <meta content={meta_keywords} name="keywords" />
                <meta property="og:title" content={meta_title} />
                <meta property="og:description" content={meta_description} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={`https://www.bluehira.com${history?.location?.pathname ? history?.location?.pathname : ""}`} />
                <meta content={meta_description} name="description" />
                <meta content={meta_title} name="title" />
            </>
        )
    }

    renderMetaTag = () => {
        return createPortal(
            this.renderMeta(),
            document.head,
        );
    }

    render() {
        const {
            cmsPage,
            isBreadcrumbsActive,
            isLoading,
        } = this.props;
        const { page_width, title, content } = cmsPage;

        if (isLoading) {
            return <Loader />;
        }

        if (!isLoading && !title && !content) {
            return <NoMatch />;
        }

        return (
            <main className="CmsPage-Main">
                <div>
                    {this.renderHeading()}
                    <div>
                        {this.renderContent()}
                    </div>
                </div>
                {this.renderMetaTag()}
            </main>
        );
    }
}

export default CmsPageComponent;
